/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as Msdyn365 from '@msdyn365-commerce/core';
export class GetSleepDisruptorIcons extends Msdyn365.CommerceEntityInput implements Msdyn365.IActionInput {
    private sleepDisuptorIconsDataUrl: string = '';
    constructor(sleepDisuptorIconsDataUrl: string) {
        super({ shouldCacheOutput: true, cacheObjectType: 'sleepDisuptorIconsDataCache', cacheKey: 'sleepDisuptorIconsDataCache' });
        this.sleepDisuptorIconsDataUrl = sleepDisuptorIconsDataUrl;
    }
    public getSleepDisuptorIconsDataUrl = () => this.sleepDisuptorIconsDataUrl;
    public getCacheKey = () => `sleepDisuptorIconsDataCache`;
    public getCacheObjectType = () => 'sleepDisuptorIconsDataCache';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}
const createInput = (inputData: Msdyn365.ICreateActionContext<Msdyn365.IGeneric<Msdyn365.IAny>>): Msdyn365.IActionInput => {
    if (inputData.config && inputData.config.sleepDisuptorIconsDataUrl) {
        return new GetSleepDisruptorIcons(inputData.config.sleepDisuptorIconsDataUrl);
    }
    return new GetSleepDisruptorIcons('');
};
async function action(input: GetSleepDisruptorIcons, ctx: Msdyn365.IActionContext): Promise<any> {
    const sleepDisuptorIconsDataJsonUrl = ctx.requestContext.app.config.sleepDisruptorIconDataUrl;
    const jsonUrl = sleepDisuptorIconsDataJsonUrl || '';
    const res = await Msdyn365.sendRequest<any>(jsonUrl, 'get');
    const sleepDisuptorIconsData = res.data && res.data;
    return sleepDisuptorIconsData;
}
export default Msdyn365.createObservableDataAction({
    id: 'SleepDisuptorIconsData',
    action: <Msdyn365.IAction<any>>action,
    input: createInput
});